/**
 * Shared office UI primitives grouped by responsibility. Keep this barrel
 * stable so consumers import from one path while each implementation remains
 * easy to locate.
 */

export * from "./Button";
export * from "./Chip";
export * from "./DragHandle";
export * from "./Feedback";
export * from "./FormControls";
export * from "./InlineAction";
export * from "./ListToolbar";
export * from "./MiniTable";
export * from "./PageNavigation";
export * from "./Pagination";
export * from "./Sections";
export * from "./Stats";
export * from "./Table";
export * from "./TrLink";
